export {default} from './QualifyingPointsContent';
